import { Component, OnInit, NgZone, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, ViewRef } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";

import { ChartsService } from '../charts-service/charts.service';
import { QueryParamsModel } from 'app/core/_base/crud';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DungChungService } from '../../dung-chung/__services/dung-chung.service';
import { CommonConFig } from '../../dung-chung/__model/common_config.model';

am4core.useTheme(am4themes_animated); 
@Component({
  selector: 'kt-tong-hop-mua-hang-stack-chart',
  templateUrl: './tong-hop-mua-hang-stack-chart.component.html',
  styleUrls: ['./tong-hop-mua-hang-stack-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class TongHopMuaHangStackChartComponent implements OnInit {
  chart: am4charts.XYChart;
  CONFIG: CommonConFig;
  categoryAxis: any;
  valueAxis : any;
  indicator;
  indicatorInterval;

  @ViewChild('searchTuNgay', { static: true }) searchTuNgay;
  @ViewChild('searchDenNgay', { static: true }) searchDenNgay;
  selectLoaiTK: string = '';
  // Filter hàng hóa
	listIdHH: any[] = [];
	selectIdHH: string[] = [];
	filteredIdHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdHHFilterCtrl: string = '';
	haveElementIdHH: boolean = false;
	
	// Filter loại hàng hóa
	listLoaiHH: any[] = [];
	selectLoaiHH: string[] = [];
	filteredLoaiHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	LoaiHHFilterCtrl: string = '';
	haveElementLoaiHH: boolean = false;
	
	// Filter nhóm nhà cc
	
	selectNNCC: string[] = [];
	filteredNNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	NNCCFilterCtrl: string = '';
  haveElementNNCC: boolean = false;
  isShowDropDown: boolean=true;
  LoaiThongKe:any[]=[
		{
			value:'MH',
			name:'Mặt hàng'
		},
		{
			value:'NCC',
			name:'Nhà cung cấp'
		}
	]


	NhomNCC:any[]=[
		{
			value:'1',
			name:'Có hệ thống ATTP'
		},
		{
			value:'2',
			name:'Không có hệ thống ATTP'
		}
  ];
  DenNgayMuaHang;
  TuNgayMuaHang;
  day= new Date();
	DayNow;
	MonthNow;
  YearNow;
  isSelectedLoaiTK:boolean=true;
  config = {

  }
  constructor(
    private zone: NgZone,
    private chartsservice: ChartsService,
    private changeDetect: ChangeDetectorRef,
    private DungChungService: DungChungService
  ) {
    
   }
   ngAfterViewInit(): void {   
	this.chart = am4core.create("chartdiv", am4charts.XYChart); 
	this.LoadData();
   }
  
   configChart(Xfield, Xtext, YText,Tooltip, data, _series: any[]= [] ){
    this.zone.runOutsideAngular(() => {  
      if (this.chart) {
        this.chart.dispose();      }      
	  let chart = am4core.create("chartdiv", am4charts.XYChart); 
	  chart.logo.height = -15;
	  chart.scrollbarX = new am4core.Scrollbar();  
	  chart.cursor = new am4charts.XYCursor(); 
	  chart.legend = new am4charts.Legend();
	  chart.cursor.lineY.disabled = true;
	  chart.cursor.lineX.disabled = true;
      //SET DATA
      chart.data = data;

      
      chart.paddingRight = 20; 
      chart.numberFormatter.numberFormat = "#a";
      chart.numberFormatter.bigNumberPrefixes = [
        { "number": 1e+3, "suffix": "N" },
        { "number": 1e+6, "suffix": "Tr" },
        { "number": 1e+9, "suffix": "T" }
      ];
      
     
    //   var title = chart.titles.create();
    //   title.text = "BIỂU ĐỒ TỔNG HỢP MUA HÀNG";
    //   title.fontWeight = "bold";
    //   title.fontSize = 20;
    //   title.marginBottom = 20;

      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = Xfield;//"MaHH";
      categoryAxis.title.text = Xtext;//"Mã hàng";
      categoryAxis.title.fontWeight = "bold";//"Mã hàng";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 20;
	  var label = categoryAxis.renderer.labels.template;
      label.truncate = true;
      label.maxWidth = 200;
      label.tooltipText = "{"+Tooltip+"}";
      categoryAxis.events.on("sizechanged", function(ev) {
        var axis = ev.target;
        var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
        if (cellWidth < axis.renderer.labels.template.maxWidth) {
          axis.renderer.labels.template.rotation = -45;
          axis.renderer.labels.template.horizontalCenter = "right";
          axis.renderer.labels.template.verticalCenter = "middle";
        }
        else {
          axis.renderer.labels.template.rotation = 0;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "top";
        }
      });
  
      var  valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = YText;//"Số lượng theo đơn vị tính";
      valueAxis.title.fontWeight = "bold";//"Số lượng theo đơn vị tính";
      for(var  i = 0 ;i<_series.length; i++ ){
        let sr1= _series[i];
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = sr1.valueY;//"SoLuongConLai";
        series.dataFields.categoryX = sr1.categoryX;//"MaHH";
        series.name = sr1.name;//"Số lượng còn lại";
        series.tooltipText = "{name}: [bold]{valueY}[/] ";
        series.stacked = true;
      }
      // if(sr1){
      //   var series = chart.series.push(new am4charts.ColumnSeries());
      //   series.dataFields.valueY = sr1.valueY;//"SoLuongConLai";
      //   series.dataFields.categoryX = sr1.categoryX;//"MaHH";
      //   series.name = sr1.name;//"Số lượng còn lại";
      //   series.tooltipText = "{name}: [bold]{valueY}[/] ";
      //   series.stacked = true;
      //   console.log("series.dataFields", series.dataFields);

      // }
      // if(sr2){
      //   var series2 = chart.series.push(new am4charts.ColumnSeries());
      //   series2.dataFields.valueY = sr2.valueY;//"SoLuongDaNhan";
      //   series2.dataFields.categoryX = sr2.categoryX;//"MaHH";
      //   series2.name = sr2.name;//"Số lượng đã nhận";
      //   series2.tooltipText = "{name}: [bold]{valueY}[/]";
      //   series2.stacked = true;
      // }  
	//  console.log("chart", this.chart);
	//  let indicator;
	//  function showIndicator() {
	//    // ...
	 
	//    let indicatorLabel = indicator.createChild(am4core.Label);
	//    indicatorLabel.text = "Loading stuff...";
	//    indicatorLabel.align = "center";
	//    indicatorLabel.valign = "middle";
	//    indicatorLabel.fontSize = 20;
	//  }
      this.chart =  chart; 
    });   
    this.changeDetectView();
   }

 showIndicator() {
	if (!this.indicator) {
		this.indicator = this.chart.tooltipContainer.createChild(am4core.Container);
		this.indicator.background.fill = am4core.color("#fff");
		this.indicator.background.fillOpacity = 0.8;
		this.indicator.width = am4core.percent(100);
		this.indicator.height = am4core.percent(100);
	
		let indicatorLabel = this.indicator.createChild(am4core.Label);
		indicatorLabel.text = "Loading stuff...";
		indicatorLabel.align = "center";
		indicatorLabel.valign = "middle";
		indicatorLabel.fontSize = 20;
		indicatorLabel.dy = 50;
		
		var hourglass = this.indicator.createChild(am4core.Image);
		hourglass.href = "https://s3-us-west-2.amazonaws.com/s.cdpn.io/t-160/hourglass.svg";
		hourglass.align = "center";
		hourglass.valign = "middle";
		hourglass.horizontalCenter = "middle";
		hourglass.verticalCenter = "middle";
		hourglass.scale = 0.7;
	  }	 
	  
	//   clearInterval(this.indicatorInterval);
	//   this.indicatorInterval = setInterval(function() {
	// 	hourglass.animate([{
	// 	  from: 0,
	// 	  to: 360,
	// 	  property: "rotation"
	// 	}], 2000);
	//   }, 3000);

 }
  hideIndicator() {
	this.indicator.hide();
	clearInterval(this.indicatorInterval);
  }
   ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }
    });
  }
  ngOnInit() {
    this.CONFIG = new CommonConFig();
    this.selectLoaiTK=this.LoaiThongKe[0].value;
		this.ListLoaiHH();
    this.ListNNCC(); 
    this.DayNow=this.day.getDate();
		this.MonthNow=this.day.getMonth() + 1; // Since getMonth() returns month from 0-11 not 1-12
		this.YearNow=this.day.getFullYear();
    this.DenNgayMuaHang=new Date(this.YearNow,this.MonthNow,0);
		this.TuNgayMuaHang= new Date(this.YearNow,this.MonthNow-1,1);
  }  
  
	ListLoaiHH() {
		
		this.DungChungService.listLoaiHH().subscribe(res => {
			// this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listLoaiHH = res.data;
				this.filteredLoaiHH.next(this.listLoaiHH.slice());
				this.changeDetect.detectChanges();
			};
		});
	}
	filterLoaiHH() {
		
		if (!this.listLoaiHH) {
			return;
		}
		// get the search keyword
		let search = this.LoaiHHFilterCtrl;
		if (!search) {
			this.filteredLoaiHH.next(this.listLoaiHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredLoaiHH.next(
			this.listLoaiHH.filter(ts =>
				ts.TenLoaiHH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	SelectLoaiHH(event: any, dependOnField: string = '') {
		if (this.selectIdHH.length >= 0 && event.length > 0)
			this.haveElementIdHH = true;
		if (this.selectIdHH.length <= 1 && event.length == 0)
			this.haveElementIdHH = false;
		if (dependOnField != '') {
		}
	}
	ClearLoaiHH() {
		this.selectIdHH = [];
		this.haveElementIdHH = false;
	}

	ListNNCC() {
	  this.filteredNNCC.next(this.NhomNCC.slice());
	}
	filterNNCC() {		
		if (!this.NhomNCC) {
			return;
		}
		// get the search keyword
		let search = this.NNCCFilterCtrl;
		if (!search) {
			this.filteredNNCC.next(this.NhomNCC.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredNNCC.next(
			this.NhomNCC.filter(ts =>
				ts.name.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	SelectNNCC(event: any, dependOnField: string = '') {
		if (this.selectIdHH.length >= 0 && event.length > 0)
			this.haveElementIdHH = true;
		if (this.selectIdHH.length <= 1 && event.length == 0)
			this.haveElementIdHH = false;
		if (dependOnField != '') {
		}
	}
	ClearNNCC() {
		this.selectIdHH = [];
		this.haveElementIdHH = false;
	}
  filterConfiguration(): any {
		const filter: any = {};		
		filter.LoaiHH = this.selectLoaiHH;
		filter.LoaiNCC=this.selectNNCC;
		filter.TuNgayMuaHang= moment(this.TuNgayMuaHang).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		filter.DenNgayMuaHang= moment(this.DenNgayMuaHang).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		// this.DateTimeFrom=filter.TuNgayMuaHang;
		// this.DateTimeTo=filter.DenNgayMuaHang;
		filter.NCC="";
		filter.HH="";
		return filter;
  }
  
	FormatDateTimeTuNgay(){		
		let tungay1=new Date()
		tungay1.setDate(tungay1.getDate()-7);	
		//Regex cho ngày tháng dạng dd/mm/yyyy hoặc dd-mm-yyyy hoặc dd.mm.yyyy
		var regex = this.CONFIG.REGEX_STR_TO_DDMMYYYY;
		var found = this.searchTuNgay.nativeElement.value.match(regex);
		if(found == null){
			this.TuNgayMuaHang=tungay1;
		}	
	}


	FormatDateTimeDenNgay(){		
		let denngay1=new Date()	
		//Regex cho ngày tháng dạng dd/mm/yyyy hoặc dd-mm-yyyy hoặc dd.mm.yyyy
		var regex = this.CONFIG.REGEX_STR_TO_DDMMYYYY;
		var found = this.searchDenNgay.nativeElement.value.match(regex);
		if(found == null){
			this.DenNgayMuaHang=denngay1;
		}
	}
	LoadData(){
		const queryParams = new QueryParamsModel(this.filterConfiguration());
			queryParams.more=true;
			if(this.selectLoaiTK==this.LoaiThongKe[0].value){
					this.isSelectedLoaiTK=true;
			  this.chartsservice.getDataTongHopMuaHang(queryParams).subscribe(res=>{
				let seris = [{
				  valueY:"SoLuongConLai",
				  categoryX: "MaHH",
				  name: "Số lượng còn lại"
				}, {
				  valueY:"SoLuongDaNhan",
				  categoryX: "MaHH",
				  name: "Số lượng đã nhận"
				}]; 
				this.configChart("MaHH","MÃ HÀNG","Số lượng theo đơn vị tính","TenHH", res.data, seris);
			  });
				}else{
					this.isSelectedLoaiTK=false; 
			  this.chartsservice.getDataTongHopMuaHangNCC(queryParams).subscribe(res=>{
				console.log("res thmh",res);
				let seris = [{
				  valueY:"ThanhTien",
				  categoryX: "MaNCC",
				  name: "Thành tiền"
				}, {
				  valueY:"Thue",
				  categoryX: "MaNCC",
				  name: "Thuế"
				}]; 
				this.configChart("MaNCC","MÃ CUNG CẤP","Thành tiền (VND)","TenNCC", res.data, seris);
			  });
				}		
	  }
  loadNCCorHH(){
    console.log(this.selectLoaiTK);
		if(this.selectLoaiTK==this.LoaiThongKe[0].value){
			this.isShowDropDown=true;
		}else{
			this.isShowDropDown=false;
		}
		 this.changeDetectView();
  }
  changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
}
